/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Button, Drawer, Switch, Modal, Select, Popconfirm } from 'antd';
import { DeleteOutlined, EditOutlined, UploadOutlined } from '@ant-design/icons'
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";

import ProjectCreate from './create';
import DynamicView from '../../DynamicViewNew/index';
import { actions } from '../../../store/reducers/project';
import { canViewFeatureAction } from "../../../constants/roles";
import { displayMessage } from "../../../helpers/Messages";
import CanAccess from "../../../helpers/CanAccess";
import { getPopupContainer } from "../../../helpers/popUp";
import PageHeader from "../../Layout/PageHeader";
import { isSuperAdmin } from "../../../constants/user";
import { DrawerHeader, ModalHeader } from "datastake-daf/dist/components";
import { CREATE_DRAWER_WIDTH } from "../../../helpers/form";

const Styles = styled.div`
	.ant-page-header {
		padding: 8px 8px 8px var(--size);
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		.ant-page-header-back-button {
			color: var(--color-primary-70);
		}
		.ant-page-header-heading {
			justify-content: flex-start;
		}
		.ant-page-header-heading-left {
			margin-top: 0;
		}
		.ant-page-header-heading-title {
			line-height: 22px;
			margin-top: 4px;
		}
		.ant-page-header-heading-extra {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			flex-grow: 1;
			margin: 0 var(--size);
			div {
				display: flex;
			}
		}
		.ant-btn {
			display: flex;
			span[role="img"] {
				font-size: 18px;
			}
		}
	}
	.ant-descriptions {
		padding: var(--size)
	}
	.ant-descriptions:not(.project) {
		width: 100%;
		// width: calc(100% / 2);
		padding-bottom: 0;
		.ant-descriptions-title {
			font-size: 14px;
			font-weight: 500;
		}
		&:nth-of-type(1) {
			.ant-descriptions-title {
				opacity: 0;
			}
		}
	}
	.ant-descriptions-item {
		padding-bottom: 6px;
		.ant-descriptions-item-label {
			font-weight: 500
		}
	}
	.ant-col{
		padding: 0px 5px;
	}
	#under-nav-tabs #tab-1:first-of-type {
		margin-left: var(--size);
	}
	.view-toggle {
		width: 80px;
	}
`;

function ProjectInfo({
  project: { data: projectData },
  authentication: { user },
  ProjectDataGet,
  ProjectRemove,
  namespace,
  module,
}) {
  const { id } = useParams();
  const { t } = useTranslation();
  const goTo = useNavigate();
  const [editVisible, setEditVisible] = useState(false);
  const [customerVisible, setCustomerVisible] = useState(false);
  const [supplierVisible, setSupplierVisible] = useState(false);
  const [isTabsView, setTabsView] = useState(StorageManager.get('datastake-view-mode') === 'section');
  const [projectProgress, setProjectProgress] = useState(null);
  const [editActiveFormIndex, setEditActiveFormIndex] = useState('');
  const [deletionVisible, setDeletionVisible] = useState(false);
  const [deletionReason, setDeletionReason] = useState(null);
  const [project, setProject] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    ProjectDataGet({ namespace, module, view: 'project', projectId: id });
  }, [id]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (projectData && projectData[`${module}-project`]) {
      const pr = projectData[`${module}-project`];
      setProject(pr)
      if (!projectProgress) {
        setProjectProgress(pr.progress);
      }
    }
  }, [projectData]);
  const isProjectApproved = () => {
    return project &&
      project.data &&
      project.data.id &&
      user &&
      user.projects &&
      Array.isArray(user.projects) &&
      user.projects.filter(p => p.projectId === project.data.id && p.status === 'approved').length > 0 ? true : false;
  }
  const canEdit = !user?.company?.id &&
    isProjectApproved() && canViewFeatureAction({ user, module, feature: 'projects', action: 'edit' })
    ;

  const canInviteCustomer = !user?.company?.id && isProjectApproved() && (canViewFeatureAction({ user, module: 'pme', feature: 'projects', action: 'inviteCustomer' }) &&
    project && project.data && !project.data.customerId) ? true : false;
  const canInviteIA = !user?.company?.id && isProjectApproved() && (canViewFeatureAction({ user, module: 'pme', feature: 'projects', action: 'inviteSupplier' }));

  const publishButton = project && project.data && project.data.datastakeId ?
    <Button
      type="link"
      key="1"
      icon={<UploadOutlined />}
      onClick={() => {
        goTo(`/app/${module}/project/${id}/publications`);
      }}>
      {t("Publish")}
    </Button> : null;
  let customerForm = {};
  let iaForm = {};
  let projectForm = {};
  if (project && project.form) {
    // if (isPmeClient) {
    // 	delete project.form.dataClient;
    // } else {
    // 	delete project.form.informationSources;
    // }
    iaForm = {
      informationSources: JSON.parse(JSON.stringify(project.form.informationSources || {})),
    };
    if (typeof iaForm.informationSources === 'object') {
      iaForm.informationSources.label = ' ';
      if (typeof iaForm.informationSources.sources === 'object') {
        iaForm.informationSources.sources.label = ' ';
        iaForm.informationSources.sources.sectionLabel = ' ';
        iaForm.informationSources.sources.canDelete = (data) => {
          return project.data && data && data.authorId !== project.data.authorId
        }
      }
    }
    customerForm = {
      dataClient: project.form.dataClient || {}
    };

    if (project.form.projectIdentification) {
      projectForm.projectIdentification = project.form.projectIdentification;
    }
    if (project.form.dataClient) {
      projectForm.dataClient = project.form.dataClient;
    }
    if (project.form.informationSources) {
      projectForm.informationSources = project.form.informationSources;
    }
    if (project.form.sca) {
      projectForm.sca = project.form.sca;
    }
    if (project.form.projectLocations) {
      projectForm.projectLocations = project.form.projectLocations;
    }
  }
  const isDemo = process.env.REACT_APP_ENV === 'demo' && !isSuperAdmin(user);

  return <CanAccess
    form={project && project.form ? project.form : {}}
    data={project && project.data ? project.data : {}}
    content={<Styles className="semibold form-input-output" style={{ height: '100%' }}>
      <PageHeader
        title={t("Project Details")}
        // onBack={() => goBack ? goBack() : goTo(`/app/${module}/projects`)}
        onBack={() => goTo(`/app/${module}/projects`)}
        extra={[
          <div key="1">
            {canEdit ? <Button
              type="link"
              key="editProject"
              icon={<EditOutlined />}
              onClick={() => setEditVisible(true)}>
              {t("Edit")}
            </Button> : null}
            {/* {canInviteCustomer ? <Button
							type="link"
							key="inviteCustomer"
							icon={<EditOutlined />}
							onClick={() => isDemo ? featureIsNotAvailable(true) : setCustomerVisible(true)}>
							{t("Invite client")}
						</Button> : null}
						{canInviteIA ? <Button
							type="link"
							key="inviteIA"
							icon={<EditOutlined />}
							onClick={() => isDemo ? featureIsNotAvailable(true) : setSupplierVisible(true)}>
							{t("Invite Information Source")}
						</Button> : null} */}
            {canEdit ? publishButton : null}
            {canEdit ? <Popconfirm
              title={t('deleteProject')}
              okText={t('Yes')}
              cancelText={t('No')}
              onConfirm={() => setDeletionVisible(true)}>
              <Button
                type="link"
                icon={<DeleteOutlined />}
                style={{ color: 'red' }}
              >
                {t("Delete")}
              </Button>
            </Popconfirm> : null}
          </div>,
          <div
            key="2"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <p style={{ margin: '0 12px 0 0' }}><strong>{t("View")}:</strong></p>
            <Switch
              checkedChildren={t("Sections")}
              unCheckedChildren={t("Full")}
              checked={isTabsView}
              onChange={(checked) => {
                if (checked) {
                  StorageManager.set('datastake-view-mode', 'section');
                } else {
                  StorageManager.set('datastake-view-mode', 'full');
                }
                setTabsView(checked)
              }}
              className="view-toggle" />
          </div>
        ]} />
      {project ?
        <DynamicView
          style={{ height: 'calc(100% - 70px)' }}
          form={project.form}
          data={project.data}
          options={project.config ? project.config.options : undefined}
          excludeKeys={[]}
          onTabChange={(ind) => setEditActiveFormIndex(ind)}
          defaultActiveKey={params.get('tab') || ''}
          tabs={isTabsView}
        />
        : null
      }
      {canEdit && editVisible && <Drawer
        destroyOnClose={true}
        title={<DrawerHeader title={t('Edit Project')} />}
        open={editVisible}
        maskClosable={false}
        onClose={() => {
          ProjectDataGet({ namespace, module, view: 'project', projectId: id });
          setEditVisible(false);
        }}
        width={CREATE_DRAWER_WIDTH}
        key="project"
        bodyStyle={{ padding: 0 }}>
        <ProjectCreate
          disabledInputs={['country']}
          namespace={namespace}
          module={module}
          view={["project", "new"]}
          projectId={id}
          info={true}
          edit={true}
          data={project.data}
          form={projectForm}
          onSubmitted={(type, m) => {
            displayMessage(type, m);
            setEditVisible(false);
            ProjectDataGet({ namespace, module, view: 'project', projectId: id });
          }}
          onCancel={() => setEditVisible(false)}
          activeFormIndex={editActiveFormIndex}
        />
      </Drawer>}

      {canInviteCustomer && customerVisible && !isDemo && <Drawer
        destroyOnClose={true}
        title={<DrawerHeader title={t('Invite Customer')} />}
        open={customerVisible}
        maskClosable={false}
        onClose={() => {
          ProjectDataGet({ namespace, module, view: 'project', projectId: id });
          setCustomerVisible(false);
        }}
        width={CREATE_DRAWER_WIDTH}
        key="customer"
        bodyStyle={{ padding: 0 }}>
        <ProjectCreate
          namespace={namespace}
          module={module}
          view={"customer"}
          showSaveAndNext={false}
          projectId={id}
          info={true}
          edit={true}
          data={project.data}
          form={customerForm}
          onSubmitted={(type, m) => {
            displayMessage(type, m);
            setCustomerVisible(false);
          }}
          onCancel={() => setCustomerVisible(false)}
          activeFormIndex={editActiveFormIndex}
        />
      </Drawer>}

      {canInviteIA && supplierVisible && !isDemo && <Drawer
        destroyOnClose={true}
        title={<DrawerHeader title={t('Invite Information Source')} />}
        open={supplierVisible}
        maskClosable={false}
        onClose={() => {
          ProjectDataGet({ namespace, module, view: 'project', projectId: id });
          setSupplierVisible(false);
        }}
        width={CREATE_DRAWER_WIDTH}
        key="supplier"
        bodyStyle={{ padding: 0 }}>
        <ProjectCreate
          showSaveAndNext={false}
          namespace={namespace}
          module={module}
          view="supplier"
          projectId={id}
          info={true}
          edit={true}
          data={project.data}
          form={iaForm}
          onSubmitted={(type, m) => {
            displayMessage(type, m);
            setSupplierVisible(false);
            ProjectDataGet({ namespace, module, view: 'project', projectId: id });
          }}
          onCancel={() => setSupplierVisible(false)}
          activeFormIndex={editActiveFormIndex}
        />
      </Drawer>}
      <Modal
        title={(
          <ModalHeader
            title={t("Delete subject")}
          />
        )}
        cancelText={t("Cancel")}
        open={deletionVisible}
        onCancel={() => setDeletionVisible(false)}
        onOk={() => {
          ProjectRemove({ id: project.data.id, data: { reason: deletionReason } }, (type, m) => {
            displayMessage(type, m);
            setDeletionVisible(false);
            setDeletionReason(null);
            goTo(`/app/${module}/projects`);
          });
        }}>
        <Select
          {...getPopupContainer()}
          onChange={ev => setDeletionReason(ev)}
          placeholder={t('Please indicate the reason for deleting this subject')}
          style={{ width: '100%' }}
        >
          <Select.Option value="Duplicate">{t('Duplicate. This subject is already identified')}</Select.Option>
          <Select.Option value="Error">{t('Issue with core data')}</Select.Option>
          <Select.Option value="Non-Existent">{t('Subject does not exist and was created by mistake')}</Select.Option>
          <Select.Option value="Other">{t('Other reason')}</Select.Option>
        </Select>
      </Modal>
    </Styles>
    } />
}

const mstp = ({ project, authentication }) => ({ project, authentication });

export default connect(mstp, actions)(ProjectInfo);
